import { getRequestSingle } from '../services/requestHandler';
import { SerialMstrDetails } from '../models/serialNumber';

export const getSerialMstr = async (serialMstrId: string): Promise<SerialMstrDetails> => {
  const url = `rnd/GetSerialMstrById?serialMstrId=${encodeURIComponent(serialMstrId)}`;
  const response = await getRequestSingle<SerialMstrDetails>('GetSerialMstrById', url);
  return response;
};

export default getSerialMstr;
